
import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    const WAVE1 = document.querySelector('.HomePage .home-latest .wave')
    //const WAVE2 = document.querySelector('.HomePage .good-milk .wave svg')
    if(!WAVE1 || WAVE1.length < 1) return

    const TIMELINE = gsap.timeline({
        scrollTrigger: {
            trigger: WAVE1,
            start: 'top 50%',
            scrub: true,
        }
    })

    TIMELINE.to(WAVE1, {
        transform: 'scale(1.5)'
    })

   /* const TIMELINE2 = gsap.timeline({
        scrollTrigger: {
            trigger: WAVE2,
            start: 'top 50%',
            scrub: true,
        }
    })

    TIMELINE2.to(WAVE2, {
        transform: 'translateX(50%) scale(2)'
    })*/

}
